import React, { useEffect, useState } from "react";
import DashboardArea from "./DashboardArea";
import DashboardMenu from "./DashboardMenu";
import {
  BranchModel,
  EnumMenuType,
  EnumPopupFunctions,
  EnumUserAcces,
  MenuItem,
  PopupInfoModel,
  ShiftModel,
} from "./Managers/dataStructures";
import Dialog from "./UtilityComponents/Dialog";
import {
  getMenuListForUserRole,
  isModulePasswordUnswitchable,
  noneBranchObject,
  noneShiftObject,
} from "./Managers/dataProvider";
import { fetchAllBranches, fetchAllShifts } from "./Managers/wepApiManager";
import { getUserAccess, getCurrentUser } from "./Managers/profileManager";

export default function DashboardMain() {
  const [isTopbarMenuOpen, setIsTopbarMenuOpen] =
    React.useState<boolean>(false);
  const [isMenuOpen_, setIsMenuOpen] = React.useState<boolean>(false);
  const [isDetailPopupOpen, setIsDetailPopupOpen] =
    React.useState<boolean>(false);
  const [popupItem, setPopupItem] = React.useState<PopupInfoModel>({
    item: null,
    ftype: EnumPopupFunctions.UNKNWON,
  });

  const [isPasswordRequired, setIsPasswordrequired] = useState<boolean>(
    getUserAccess() === EnumUserAcces.TEAM_LEAD ? true : false
  );
  const [selectedMenu, setSelectedMenu] = React.useState<MenuItem>(
    getMenuListForUserRole(getUserAccess())[0]
  );

  const [array_branches, setArray_Branches] = useState<BranchModel[]>([]);
  const [array_shifts, setArray_Shifts] = useState<ShiftModel[]>([]);

  useEffect(() => {
    fetchAllBranches((array_AllBranches) => {
      let tempBranches = array_AllBranches;
      tempBranches = [noneBranchObject(), ...tempBranches];
      //tempBranches.push(noneBranchObject());
      setArray_Branches(tempBranches);
    });
    if (
      getUserAccess() === EnumUserAcces.SHIFT_PLANER ||
      getUserAccess() === EnumUserAcces.DEV
    ) {
      fetchAllShifts((array_shifts_: ShiftModel[]) => {
        let tempShifts = array_shifts_;
        tempShifts = [noneShiftObject(), ...tempShifts];
        //tempShifts.push(noneShiftObject());
        setArray_Shifts(tempShifts);
      });
    }
  }, []);

  function menuClose_() {
    setIsMenuOpen(false);
  }

  function restoreDefaultTab() {
    setSelectedMenu(getMenuListForUserRole(getUserAccess())[0]);
  }

  function openMenuMobile() {
    setIsMenuOpen(true);
  }

  function openTopbarMenu() {
    if (isTopbarMenuOpen) {
      setIsTopbarMenuOpen(false);
    } else {
      if (isPasswordRequired === true) {
        const item: PopupInfoModel = {
          item: getCurrentUser(),
          ftype: EnumPopupFunctions.MAIN_MENU_PASSWORD_REQUIRED_LOGIN_DIALOG,
          callback: () => {
            setIsDetailPopupOpen(false);
            setIsMenuOpen(false);
            setIsTopbarMenuOpen(true);
          },
        };
        setPopupItem(item);
        setIsDetailPopupOpen(true);
      } else {
        setIsTopbarMenuOpen(true);
      }
    }
  }

  function menuSelectionHandler(menuItem: MenuItem) {
    if (
      isPasswordRequired === true &&
      menuItem.menuType !== selectedMenu.menuType
    ) {
      const item: PopupInfoModel = {
        item: getCurrentUser(),
        ftype: EnumPopupFunctions.MAIN_MENU_PASSWORD_REQUIRED_LOGIN_DIALOG,
        callback: () => {
          setIsDetailPopupOpen(false);
          setIsMenuOpen(false);
          setSelectedMenu(menuItem);
          setIsPasswordrequired(false);
          setIsPasswordrequired(
            isModulePasswordUnswitchable(menuItem.menuType)
          );
        },
      };

      setPopupItem(item);
      setIsDetailPopupOpen(true);
    } else {
      setIsMenuOpen(false);
      setSelectedMenu(menuItem);
      setIsPasswordrequired(isModulePasswordUnswitchable(menuItem.menuType));
    }
  }

  function menuSelectionHandlerViaArea(item_: EnumMenuType) {
    if (
      item_ === EnumMenuType.CHANGE_PASSWORD_SELF ||
      item_ === EnumMenuType.CHANGE_PASSWORD_ADMIN
    ) {
      if (item_ === EnumMenuType.CHANGE_PASSWORD_SELF) {
        const item_ele: PopupInfoModel = {
          item: getCurrentUser(),
          props: null,
          ftype: EnumPopupFunctions.CHANGE_PASSWORD_SELF,
        };
        setPopupItem(item_ele);
        setIsDetailPopupOpen(true);
      } else if (item_ === EnumMenuType.CHANGE_PASSWORD_ADMIN) {
        const item_ele: PopupInfoModel = {
          item: getCurrentUser(),
          props: null,
          ftype: EnumPopupFunctions.CHANGE_PASSWORD_ADMIN,
        };
        setPopupItem(item_ele);
        setIsDetailPopupOpen(true);
      }
    } else {
      const item: MenuItem = {
        id: 7,
        title: "",
        icon: "",
        menuType: item_,
      };
      setSelectedMenu(item);
    }
  }

  function closePopup() {
    setPopupItem({ item: null, ftype: EnumPopupFunctions.UNKNWON });
    setIsDetailPopupOpen(false);
  }

  function redirectControl(item: PopupInfoModel) {
    switch (item.ftype) {
      case EnumPopupFunctions.TL_USER_LOGIN_DIALOG: {
        const item_ele: PopupInfoModel = {
          item: item.item,
          props: item.props,
          ftype: EnumPopupFunctions.TL_USER_LOGIN_DIALOG_REDIRECTION,
        };
        setPopupItem(item_ele);
        break;
      }
      case EnumPopupFunctions.ALERT_DIALOG: {
        const item_ele: PopupInfoModel = {
          item: item.item,
          props: item.props,
          ftype: EnumPopupFunctions.ALERT_DIALOG,
        };
        setPopupItem(item_ele);
        break;
      }
      case EnumPopupFunctions.TL_FORCE_CLOSE_DIALOG: {
        closePopup();
        break;
      }
      case EnumPopupFunctions.TL_END_SHIFT_DIALOG: {
        return true;
      }
    }
  }

  function openReturnDialog(item: PopupInfoModel) {
    switch (item.ftype) {
      case EnumPopupFunctions.TL_END_SHIFT_DIALOG:
        setPopupItem(item);
        setIsDetailPopupOpen(true);
        break;
      default:
        setPopupItem({ item: null, ftype: EnumPopupFunctions.UNKNWON });
        setIsDetailPopupOpen(false);
        break;
    }
    return false;
  }

  function openDetailPopup(item: PopupInfoModel) {
    switch (item.ftype) {
      case EnumPopupFunctions.USER_DETAIL:
        setPopupItem(item);
        setIsDetailPopupOpen(true);
        break;
      case EnumPopupFunctions.ADD_USER:
        setPopupItem(item);
        setIsDetailPopupOpen(true);
        break;
      case EnumPopupFunctions.EDIT_USER:
        setPopupItem(item);
        setIsDetailPopupOpen(true);
        break;
      case EnumPopupFunctions.ADD_BRANCH:
        setPopupItem(item);
        setIsDetailPopupOpen(true);
        break;
      case EnumPopupFunctions.BRANCH_DETAIL:
        setPopupItem(item);
        setIsDetailPopupOpen(true);
        break;
      case EnumPopupFunctions.ADD_SHIFT:
        setPopupItem(item);
        setIsDetailPopupOpen(true);
        break;
      case EnumPopupFunctions.EDIT_SHIFT:
        setPopupItem(item);
        setIsDetailPopupOpen(true);
        break;
      case EnumPopupFunctions.TL_USER_LOGIN_DIALOG:
        setPopupItem(item);
        setIsDetailPopupOpen(true);
        break;
      case EnumPopupFunctions.TL_FORCE_CLOSE_DIALOG:
        setPopupItem(item);
        setIsDetailPopupOpen(true);
        break;
      case EnumPopupFunctions.TL_END_SHIFT_DIALOG:
        setPopupItem(item);
        setIsDetailPopupOpen(true);
        break;
      case EnumPopupFunctions.BM_REPORT_DETAIL:
        setPopupItem(item);
        setIsDetailPopupOpen(true);
        break;
      case EnumPopupFunctions.ADMIN_REPORT_DETAIL:
        setPopupItem(item);
        setIsDetailPopupOpen(true);
        break;
      case EnumPopupFunctions.ALERT_DIALOG:
        setPopupItem(item);
        setIsDetailPopupOpen(true);
        break;
      case EnumPopupFunctions.CHANGE_PASSWORD_SELF:
        setPopupItem(item);
        setIsDetailPopupOpen(true);
        break;
      case EnumPopupFunctions.CHANGE_PASSWORD_ADMIN:
        setPopupItem(item);
        setIsDetailPopupOpen(true);
        break;
      case EnumPopupFunctions.CLOSE:
        setPopupItem({ item: null, ftype: EnumPopupFunctions.UNKNWON });
        setIsDetailPopupOpen(false);
        break;

      default:
        setPopupItem({ item: null, ftype: EnumPopupFunctions.UNKNWON });
        setIsDetailPopupOpen(false);
        break;
    }
  }

  return (
    <div className="flex min-h-full flex-row h-screen">
      <DashboardMenu
        menuSelectionHandler={menuSelectionHandler}
        menuClose={menuClose_}
        isMenuOpen={isMenuOpen_}
      />
      {isDetailPopupOpen
        ? Dialog(popupItem, closePopup, redirectControl)
        : null}
      <DashboardArea
        selectedMenuItem={selectedMenu}
        menuSelectionHandler={menuSelectionHandlerViaArea}
        openMenuMobile={openMenuMobile}
        openDetailPopup={openDetailPopup}
        openReturnPopup={openReturnDialog}
        onTopbarMenuOpen={openTopbarMenu}
        restoreDefaultTab={restoreDefaultTab}
        isTopbarMenuOpen={isTopbarMenuOpen}
        array_branches={array_branches}
        array_shifts={array_shifts}
      />
    </div>
  );
}
